const QUEUE_LIMIT = 50;
const FLUSH_INTERVAL_MS = 1000;

const getSinkUrl = () =>
    // eslint-disable-next-line no-process-env -- CRA exposes config via REACT_APP_* at build time.
    process.env.REACT_APP_LOG_SINK_URL || '';

const queue = [];
let flushTimer = null;

const sendBatch = (batch, sinkUrl) => {
    try {
        globalThis
            .fetch(sinkUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(batch),
                keepalive: true,
            })
            .catch(() => {});
    } catch {
        // Synchronous fetch failure (e.g., fetch unavailable) — silent.
    }
};

const flush = () => {
    flushTimer = null;
    if (queue.length === 0) {
        return;
    }
    const sinkUrl = getSinkUrl();
    const batch = queue.splice(0, queue.length);
    if (sinkUrl) {
        sendBatch(batch, sinkUrl);
    }
};

const scheduleFlush = () => {
    if (flushTimer !== null) {
        return;
    }
    flushTimer = setTimeout(flush, FLUSH_INTERVAL_MS);
};

export const enqueueLog = (entry) => {
    if (!getSinkUrl()) {
        return;
    }
    if (queue.length >= QUEUE_LIMIT) {
        queue.shift();
    }
    queue.push(entry);
    scheduleFlush();
};

export const __testing = {
    flushNow: flush,
    queueSize: () => queue.length,
    reset: () => {
        queue.length = 0;
        if (flushTimer !== null) {
            clearTimeout(flushTimer);
            flushTimer = null;
        }
    },
};
